import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
type Slide = {
  src: string;
  alt: string;
};
type Props = {
  slides: Slide[];
  label: string;
};
export function ImageCarousel({
  slides,
  label
}: Props) {
  const trackRef = useRef<HTMLDivElement>(null);
  const scroll = (dir: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    const slide = track.querySelector<HTMLElement>('[data-slide]');
    const step = slide ? slide.offsetWidth + 16 : track.clientWidth * 0.8;
    track.scrollBy({
      left: dir * step,
      behavior: 'smooth'
    });
  };
  const arrow = 'absolute top-1/2 z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-grape/20 bg-white text-grape shadow-md transition-[background-color,transform] duration-150 ease-out hover:bg-lilac-soft active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-grape sm:flex';
  return <div className="relative" data-id="element-92" data-mp="i0d98qqj0csx">
      <div ref={trackRef} role="region" aria-label={label} tabIndex={0} className="-mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth px-5 pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-93" data-mp="4qtlfmjcwcev">
        {slides.map(img => <div key={img.src} data-slide className="w-[68%] shrink-0 snap-start sm:w-[38%]" data-id="element-94" data-mp="9qfz1x33juo7">
            <img src={img.src} alt={img.alt} width={1080} height={1350} loading="lazy" className="aspect-[4/5] w-full rounded-2xl border border-grape/15 bg-white object-cover shadow-[0_14px_30px_-22px_rgba(7,35,26,0.45)]" data-id="element-95" data-mp="of2b9pxfg6b7" />
          </div>)}
        <div className="w-1 shrink-0" aria-hidden="true" data-id="element-96" data-mp="shz0w0ldx2on" />
      </div>

      <button type="button" onClick={() => scroll(-1)} aria-label="Previous image" className={`${arrow} -left-3`} data-id="element-97" data-mp="2z6loznk5eq03">
        <ChevronLeftIcon className="h-5 w-5" data-id="element-98" data-mp="2u8tvip3uuvts" />
      </button>
      <button type="button" onClick={() => scroll(1)} aria-label="Next image" className={`${arrow} -right-3`} data-id="element-99" data-mp="y4vyibtivw37">
        <ChevronRightIcon className="h-5 w-5" data-id="element-100" data-mp="133qpi11n8qye" />
      </button>
    </div>;
}